export enum ChipSizeEnum {
  XSMALL  = "mp-chip-xsmall",
  SMALL   = "mp-chip-small",
  MEDIUM  = "mp-chip-medium",
  LARGE   = "mp-chip-large"
}
